export default __webpack_public_path__ + "static/media/b.341ed505.svg";